import { RefObject } from "react"

export const getScrollPosition = (element: HTMLElement | null) => {
  if (element) {
    const rect = element.getBoundingClientRect()
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    const elementCenterY = rect.top + scrollTop + rect.height / 2
    const targetScrollTop = elementCenterY - window.innerHeight / 2

    window.scrollTo({ top: targetScrollTop, behavior: "smooth" })
  }
}

export const scrollToCardById = (
  id: string,
  items: any[],
  sliceEndNumber: number,
  displayMore: () => void,
  retryDelay = 505,
) => {
  const tryScroll = () => {
    const el = document.getElementById(id)
    if (el) return getScrollPosition(el)

    if (sliceEndNumber < items.length) {
      displayMore()
      setTimeout(tryScroll, retryDelay)
    }
  }
  tryScroll()
}

export const scrollToCardByRef = (
  colorCode: string,
  items: any[],
  sliceEndNumber: number,
  displayMore: () => void,
  cardRefs: React.MutableRefObject<Record<string, HTMLDivElement | null>>,
  retryDelay = 505,
) => {
  const tryScroll = () => {
    const el = cardRefs.current[colorCode]
    if (el) return getScrollPosition(el)

    if (sliceEndNumber < items.length) {
      displayMore()
      setTimeout(tryScroll, retryDelay)
    }
  }
  tryScroll()
}

// get color from scroller
export const getColorFromAnchorPosition = (
  x: number,
  scrollerRef: RefObject<HTMLDivElement>,
  colorArray: string[],
) => {
  const scroller = scrollerRef.current
  if (!scroller) return

  const rect = scroller.getBoundingClientRect()
  const relativeX = Math.min(Math.max(x - rect.left, 0), rect.width)
  const percent = relativeX / rect.width
  const index = Math.floor(percent * (colorArray.length - 1))
  return colorArray[index]
}
